<template>
  <div class="date-picker">
    <date-picker
      :range="true"
      :confirm="true"
      :clearable="false"
      :editable="!disabled"
      :confirm-text="confirmText"
      :placeholder="placeholder"
      :value="value"
      :format="displayFormat"
      :disabled-date="disabledDate"
      :disabled="disabled"
      @change="handleChange"
    />
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
export default {
  components: { DatePicker },
  props: {
    confirmText: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    displayFormat: {
      type: String,
      default: 'YYYY-MM-DD',
    },
    value: {
      type: Array,
      default: () => [],
    },
    disabledDate: {
      type: Function,
      default: () => false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleChange(value) {
      this.$emit('change', value);
    },
  },
};
</script>
